import * as React from "react";
import type { ResultDetails } from "@/modules/snapshots/businessReports.types";
import { ContractFamilySummaryDetails } from "@/modules/snapshots/resultDetails/ContractFamilySummaryDetails";
import {
  hasContractFamilySummaryContent,
  parseContractFamilySummary,
} from "@/modules/snapshots/resultDetails/contractFamilySummary";

type Renderer = (data: Record<string, unknown>) => React.ReactNode;

/**
 * One renderer per envelope `kind@version`. The envelope is written by the backend, never by the
 * model, so the key is trusted; `data` is not. An unknown kind or a newer version renders nothing:
 * the cell's plain `result` above is the fallback every client can show.
 */
const RENDERERS: Record<string, Renderer> = {
  "contract_family_summary@1": data => {
    const summary = parseContractFamilySummary(data);
    return hasContractFamilySummaryContent(summary) ? <ContractFamilySummaryDetails summary={summary} /> : null;
  },
};

interface Props {
  details: ResultDetails | null | undefined;
}

export const ResultDetailsSection: React.FC<Props> = ({ details }) => {
  if (!details || typeof details.data !== "object" || details.data === null) return null;
  const render = Object.hasOwn(RENDERERS, `${details.kind}@${details.version}`)
    ? RENDERERS[`${details.kind}@${details.version}`]
    : null;
  return render ? <>{render(details.data)}</> : null;
};
